module.exports = __webpack_public_path__ + "static/media/carouselone.457c646d.png";